export default __webpack_public_path__ + "static/media/maialeTtsIt_It60.3fbf03e9.mp3";